import React, { useState, useEffect } from "react";
import {
  PulseButton,
  PulseButtonTheme,
  PulseDropdown,
  PulsePopupContainerSize,
} from "@pulselabs-ai/shared-fe-ui";
import { AddRoundedIcon } from "../../../components/icons";
import TriggerCard from "../../../components/TriggerCard/TriggerCard";
import CustomDialog from "../../../components/customDialog/CustomDialog";
import { ActionType } from "@pl-flight-recorder/common/models/enum/action-type.enum";
// import FeedbackForm from "../../../components/FeedbackForm/FeedbackForm";
// import { FeedbackFormData } from "../../../types/feedback-form.types";
import MfaCaptureMethodService, {
  CaptureMethod,
  CaptureMethodStatus,
  // CaptureMethodInput,
} from "../../../services/MfaCaptureMethodService";
// import { ActionType } from "@pl-flight-recorder/common/models/enum/action-type.enum";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../store/hooks";
import SurveyForm from "@pl-flight-recorder/web/components/SurveyForm/SurveyForm";
import { SurveyJson } from "@pl-flight-recorder/web/components/SurveyForm/SurveyForm";

const TriggerContent: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const userData = useAppSelector((state) => state.user.user);
  const userId = userData?.id;
  const token = userData?.token;
  const workspaceId = userData?.defaultWorkspace?.id?.toString() || "";
  const [selectedStatus, setSelectedStatus] = useState<string>("All");
  // const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [captures, setCaptures] = useState<CaptureMethod[]>([]);
  // const [feedbackFormData, setFeedbackFormData] =
  //   useState<CaptureMethod | null>(null);
  const [isSurveyFormOpen, setSurveyFormOpen] = useState(false);
  const [surveyData, setSurveyData] = useState<SurveyJson | null>(null);
  const [editCaptureId, setEditCaptureId] = useState<number | null>(null);
  const isFuture = false;

  useEffect(() => {
    if (projectId && token) {
      handleGetCaptures();
    }
  }, [projectId, token]);

  // const handleFeedbackSubmit = (formData: FeedbackFormData) => {
  //   console.log("Form created:", formData);
  //   setIsFeedbackModalOpen(false);
  //   // reload captures
  //   handleGetCaptures();
  // };

  const handleGetCaptures = async () => {
    try {
      if (!projectId) return;
      // setIsLoading(true);
      const mfaCaptureMethodService = MfaCaptureMethodService.getInstance();
      const response =
        await mfaCaptureMethodService.getCapturesByProjectId(projectId);
      setCaptures(response.data);
    } catch (error) {
      console.error("Failed to get captures:", error);
      setError(
        error instanceof Error ? error.message : "Failed to fetch captures",
      );
    } finally {
      // setIsLoading(false);
    }
  };

  const handleDuplicate = async (captureId: number) => {
    try {
      if (!token) {
        console.error("No token available");
        return;
      }
      console.log("handleDuplicate", captureId, token);

      const captureService = MfaCaptureMethodService.getInstance();
      await captureService.duplicateCapture(captureId, token, workspaceId);

      // Refresh the captures list
      handleGetCaptures();
    } catch (error) {
      console.error("Failed to duplicate capture:", error);
      setError(
        error instanceof Error ? error.message : "Failed to duplicate capture",
      );
    }
  };

  const handlePause = async (captureId: number) => {
    try {
      if (!token || !userId) {
        console.error("No token or userId available");
        return;
      }

      const captureService = MfaCaptureMethodService.getInstance();
      await captureService.updateCaptureStatus(
        captureId,
        "Paused",
        // CaptureMethodStatus.Paused,
        userId.toString(),
        token,
        workspaceId,
      );

      // Refresh captures
      handleGetCaptures();
    } catch (error) {
      console.error("Failed to pause capture:", error);
      setError(
        error instanceof Error ? error.message : "Failed to pause capture",
      );
    }
  };

  const handleActivate = async (captureId: number, active: boolean) => {
    console.log("handleActivate", captureId, active);
    try {
      if (!token || !userId) {
        console.error("No token or userId available");
        return;
      }

      const captureService = MfaCaptureMethodService.getInstance();
      await captureService.updateCaptureStatus(
        captureId,
        active ? "Active" : "Inactive",
        userId.toString(),
        token,
        workspaceId,
      );

      // Refresh captures
      handleGetCaptures();
    } catch (error) {
      console.error("Failed to activate capture:", error);
      setError(
        error instanceof Error ? error.message : "Failed to activate capture",
      );
    }
  };

  const handleLaunch = async (captureId: number) => {
    try {
      if (!token || !userId) {
        console.error("No token or userId available");
        return;
      }

      const captureService = MfaCaptureMethodService.getInstance();
      await captureService.updateCaptureStatus(
        captureId,
        "Launched",
        // CaptureMethodStatus.Paused,
        userId.toString(),
        token,
        workspaceId,
      );

      // Refresh captures
      handleGetCaptures();
    } catch (error) {
      console.error("Failed to pause capture:", error);
      setError(
        error instanceof Error ? error.message : "Failed to pause capture",
      );
    }
  };

  const handleResume = async (captureId: number) => {
    try {
      if (!token || !userId) {
        console.error("No token or userId available");
        return;
      }

      const captureService = MfaCaptureMethodService.getInstance();
      await captureService.updateCaptureStatus(
        captureId,
        "Launched",
        // CaptureMethodStatus.Launched,
        userId.toString(),
        token,
        workspaceId,
      );

      // Refresh captures
      handleGetCaptures();
    } catch (error) {
      console.error("Failed to pause capture:", error);
      setError(
        error instanceof Error ? error.message : "Failed to pause capture",
      );
    }
  };

  const handleDeactivate = async (captureId: number) => {
    try {
      if (!token || !userId) {
        console.error("No token or userId available");
        return;
      }

      const captureService = MfaCaptureMethodService.getInstance();
      await captureService.updateCaptureStatus(
        captureId,
        "Closed",
        // CaptureMethodStatus.Closed,
        userId.toString(),
        token,
        workspaceId,
      );

      // Refresh captures
      handleGetCaptures();
    } catch (error) {
      console.error("Failed to pause capture:", error);
      setError(
        error instanceof Error ? error.message : "Failed to pause capture",
      );
    }
  };

  const handleEdit = async (captureId: number) => {
    try {
      if (!token) {
        console.error("No token available");
        return;
      }
      const captureService = MfaCaptureMethodService.getInstance();
      const capture = await captureService.getCaptureMethod(captureId);

      const parsedSchema =
        typeof capture.surveySchema === "string"
          ? JSON.parse(capture.surveySchema)
          : capture.surveySchema;

      console.log("parsedSchema", parsedSchema);
      setEditCaptureId(captureId);
      setSurveyData(parsedSchema);
      setSurveyFormOpen(true);
    } catch (error) {
      console.error("Failed to get capture for editing:", error);
      setError(
        error instanceof Error ? error.message : "Failed to get capture",
      );
    }
  };

  const handleSaveSurvey = async (surveyData: SurveyJson) => {
    // TODO rewrite for custom Trigger
    try {
      if (!projectId || !token || !userId) {
        console.error("Project ID, token and userId are required");
        return;
      }

      const captureService = MfaCaptureMethodService.getInstance();
      const data = {
        projectId,
        actionType: ActionType.Custom,
        screenRecordingConf: {},
        surveySchema: {
          title: surveyData.title || "Untitled Form",
          description: surveyData.description || "",
          pages: surveyData.pages || [],
        },
        status: CaptureMethodStatus.Active,
      };

      if (editCaptureId) {
        // Update existing survey
        // await captureService.updateCapture(
        //   editCaptureId,
        //   data,
        //   token,
        //   workspaceId,
        // );
      } else {
        // Create new survey
        await captureService.createCapture(data, token, workspaceId);
      }

      handleGetCaptures();
      setSurveyFormOpen(false);
      setSurveyData(null);
      setEditCaptureId(null);
    } catch (error) {
      console.error("Failed to save survey:", error);
      setError(
        error instanceof Error ? error.message : "Failed to save survey",
      );
    }
  };

  const handleAddTrigger = () => {
    setSurveyData(null);
    setEditCaptureId(null);
    console.log("surveyData Add", surveyData);
    setSurveyFormOpen(true);
  };

  const filteredCaptures = captures.filter((capture) => {
    if (selectedStatus === "All") return true;

    // Convert status to match the dropdown values
    const statusMap = {
      Draft: "DRAFT",
      InProgress: "ACTIVE",
      Paused: "PAUSED",
      Closed: "INACTIVE",
      Launched: "LAUNCHED",
    };

    return (
      capture.status === statusMap[selectedStatus as keyof typeof statusMap]
    );
  });

  return (
    <div className="trigger-content">
      {error && <div className="error-message">{error}</div>}

      <div className="action-row">
        <PulseDropdown
          selectedValue={selectedStatus}
          onChange={(value) => setSelectedStatus(value)}
          options={[
            { label: "ALL", value: "All" },
            { label: "DRAFT", value: "Draft" },
            { label: "IN PROGRESS", value: "InProgress" },
            { label: "PAUSED", value: "Paused" },
            { label: "DEACTIVATED", value: "Closed" },
          ]}
          style={{ width: "200px" }}
        />
        {isFuture && (
          <PulseButton
            theme={PulseButtonTheme.SECONDARY}
            className="add-custom-action"
            startIcon={<AddRoundedIcon />}
            onClick={() => handleAddTrigger()}
          >
            ADD TRIGGER
          </PulseButton>
        )}
      </div>
      {/* // display project ID */}

      {/* // Use these properties for the card below:  "surveySchema": "{\"title\":\"Provide Feedback\",\"description\":\"A screen capture, the network performance, and app usage logs for the past 15 seconds will be sent.\",\"questions\":[{\"id\":\"feedback_type\",\"question\":\"What kind of feedback are you providing?\",\"type\":\"Radio\",\"options\":[\"Bug\",\"Usability\",\"Feature\",\"Insight\"]},{\"id\":\"additional_comments\",\"question\":\"Any additional comments\",\"type\":\"LongText\"}]}" */}
      {/* {<pre>{JSON.stringify(captures[0].surveySchema, null, 2)}</pre>} */}
      <div className="feedback-cards">
        {filteredCaptures.map((capture) => {
          let surveyData;

          try {
            // Check if it's already an object
            surveyData =
              typeof capture.surveySchema === "string"
                ? JSON.parse(capture.surveySchema)
                : capture.surveySchema;
          } catch {
            surveyData = { title: "parse error" };
            console.error(
              "Failed to parse survey schema:",
              capture.surveySchema,
            );
          }

          console.log("surveyData", surveyData);
          console.log("capture", capture);
          // const questionsCount = surveyData.pages?.[0]?.elements?.length || 0;

          return (
            <TriggerCard
              key={capture.captureId}
              triggerId={capture.captureId.toString()}
              projectId={projectId || ""}
              title={surveyData.title || "Untitled Capture"}
              status={capture.status}
              triggerType={capture.actionType}
              rowCount=""
              onViewCode={() =>
                console.log("View code clicked", capture.captureId)
              }
              surveySchema={surveyData}
              currentSurveyId={capture.surveyId.toString()}
              onEdit={() => handleEdit(capture.captureId)}
              onPause={() => handlePause(capture.captureId)}
              onResume={() => handleResume(capture.captureId)}
              onDuplicate={() => handleDuplicate(capture.captureId)}
              onDeactivate={() => handleDeactivate(capture.captureId)}
              launchCustomAction={() => handleLaunch(capture.captureId)}
              onActivate={(e: boolean) => handleActivate(capture.captureId, e)}
              onTriggerChanged={() => handleGetCaptures()}
            />
          );
        })}
      </div>

      <CustomDialog
        isOpen={isSurveyFormOpen}
        onClose={() => {
          setSurveyFormOpen(false);
          setSurveyData(null);
          setEditCaptureId(null);
        }}
        containerSize={PulsePopupContainerSize.CUSTOM}
        roundedCorners={true}
        isBackgroundClose={false}
      >
        <SurveyForm
          onClose={() => {
            setSurveyFormOpen(false);
            setSurveyData(null);
            setEditCaptureId(null);
          }}
          onSave={handleSaveSurvey}
          isEditing={!!surveyData}
          initialData={surveyData || undefined}
        />
      </CustomDialog>

      {/* <CustomDialog
        isOpen={isFeedbackModalOpen}
        onClose={() => {
          setIsFeedbackModalOpen(false);
        }}
        containerSize={PulsePopupContainerSize.CUSTOM}
        showCloseIcon={true}
        isBackgroundClose={false}
        roundedCorners={true}
      >
        <FeedbackForm
          projectId={projectId}
          onClose={() => {
            console.log("Close clicked");
            setIsFeedbackModalOpen(false);
            setFeedbackFormData(null);
          }}
          onSave={(json) => {
            console.log("Save json", json);
          }}
          onSubmit={handleFeedbackSubmit}
          initialData={feedbackFormData}
          isEditing={!!feedbackFormData}
        />
      </CustomDialog> */}
    </div>
  );
};

export default TriggerContent;
